// @ts-strict-ignore
const clearApolloStore = (apolloHookClient) => {
	apolloHookClient.stop();
	apolloHookClient.clearStore();
};

export default clearApolloStore;
